const encodeQueryParamValue = (value, paramName) => {
    if (!value) return '';

    try {
        // Normalize values that may already contain percent-encoded segments.
        // We use replace(/\+/g, ' ') to handle '+' as spaces, which is standard for application/x-www-form-urlencoded
        // Exception: email parameters should preserve '+' characters.
        const decodedValue = decodeURIComponent(
            paramName === 'email' ? value : value.replaceAll(/\+/g, ' ')
        );
        return encodeURIComponent(decodedValue);
    } catch (error) {
        // Fallback for malformed values: encode raw input to make parsing reliable.
        if (error) {
            return encodeURIComponent(value);
        }
    }
};
export const sanitizeSearch = ({ search, paramList }) => {
    if (!search || search === '?') {
        return search || '';
    }

    const rawSearch = search.startsWith('?') ? search.slice(1) : search;

    if (!rawSearch) {
        return '';
    }

    const matches = [];

    paramList.forEach(param => {
        // Find only known keys so we don't unexpectedly mutate unrelated params.
        const regex = new RegExp(`(?:^|&)${param}=`, 'g');
        let match = regex.exec(rawSearch);

        while (match) {
            matches.push({
                param,
                index: match.index + (match[0].startsWith('&') ? 1 : 0),
            });
            match = regex.exec(rawSearch);
        }
    });

    if (!matches.length) {
        return search;
    }

    matches.sort((a, b) => a.index - b.index);

    let cursor = 0;
    const sanitizedParts = [];

    matches.forEach((match, index) => {
        const keyStart = match.index;
        const valueStart = keyStart + match.param.length + 1;
        const nextParamStart =
            index < matches.length - 1 ? matches[index + 1].index : rawSearch.length;
        // Value ends right before the next matched key (if any).
        const valueEnd =
            index < matches.length - 1 && rawSearch[nextParamStart - 1] === '&'
                ? nextParamStart - 1
                : nextParamStart;

        const rawValue = rawSearch.slice(valueStart, valueEnd);

        sanitizedParts.push(
            rawSearch.slice(cursor, keyStart),
            `${match.param}=${encodeQueryParamValue(rawValue, match.param)}`
        );

        cursor = valueEnd;
    });

    sanitizedParts.push(rawSearch.slice(cursor));

    return `?${sanitizedParts.join('')}`;
};
export const sanitizeURL = ({ url, paramList }) => {
    const parsedURL = new URL(url);
    const sanitizedSearch = sanitizeSearch({ search: parsedURL.search, paramList });

    if (sanitizedSearch === parsedURL.search) {
        return url;
    }

    parsedURL.search = sanitizedSearch;

    return parsedURL.toString();
};
export const getQueryParameter = (search, param) => {
    const query = new URLSearchParams(search);
    return isNaN(parseInt(query.get(param))) ? null : parseInt(query.get(param));
};
export const getQueryParameterString = (search, param) => {
    const query = new URLSearchParams(search);
    return query.get(param);
};
